<ftr-page-layout
  [name]="name"
  [loadingTemplate]="loadingTemplate"
  [emptyBodyTemplate]="emptyTemplate"
  [bodyTemplate]="main"
  [entity]="entity"
  [horizontalAutoMargin]="false"
  [horizontalOuterMargin]="false"
  [noMargin]="noMargin"
  [errorMessage]="errorMessage"
  [isEmptyFunction]="isEmptyFunction"
  (onRetry)="onRetry.emit()"
>
  <ng-template #main let-vm>
    <div>
      <div>
        <ng-container *ngTemplateOutlet="wideHeaderTemplate; context: { $implicit: vm }"></ng-container>
      </div>

      <div [class]="mainContainerClass">
        <ng-container *ngTemplateOutlet="bodyTemplate; context: { $implicit: vm }"></ng-container>
      </div>
    </div>
  </ng-template>
</ftr-page-layout>
